import DirectDebitPadMandate from './direct-debit-pad-mandate';

export default DirectDebitPadMandate;
